var React = require("react");
const validator = require("validator");
const createReactClass = require("create-react-class");

var DomainInfo = createReactClass({
	getInitialState: function() {
		return {
			DomainInfo: this.props.data
		}
	},

	getARecords: function() {
		let aRecordInfo = null;
		if (this.state.DomainInfo.A.length) {
			const aRecords = this.state.DomainInfo.A.map((record) => {
				let type = "A";
				if (validator.isIP(record, 6)) {
					type = "AAAA";
				}
				return (<li><code>{type} {record}</code></li>)
			});

			aRecordInfo = (
				<div>
					<p>For domains that do not contain subdomains set the following DNS records:</p>
					<ul className="list-unstyled">{aRecords}</ul>
				</div>
			)
		}

		return aRecordInfo;
	},

	getCNAMERecords: function() {
		let cnameRecordInfo = null;
		if (this.state.DomainInfo.CNAME.length) {
			const cnameRecords = this.state.DomainInfo.CNAME.map((record) =>
				<li><code>CNAME {record}</code></li>
			);

			cnameRecordInfo = (
				<div>
					<p>For domains that contain subdomains (including <code>www</code>) set the following DNS records:</p>
					<ul className="list-unstyled">{cnameRecords}</ul>
				</div>
			)
		}

		return cnameRecordInfo;
	},

	render: function() {
		var description = null;
		var aEl = <abbr title="Address record (abbreviated as A record) links a domain to an IP address">A</abbr>;
		var cnameEl = <abbr title="Canonical Name record (abbreviated as CNAME record) is used to specify that a domain name is an alias for another domain">CNAME</abbr>;
		var info = this.state.DomainInfo;

		switch (info.type) {
			case 'message':
				description = (
					<div dangerouslySetInnerHTML={{__html:info.message}} />
				);
				break;
			case 'ELB':
				description = (
					<ul>
						<li>Set {cnameEl} records to <code>{info.CNAME}</code></li>
						<li>
							Using {aEl} records is not possible with this stack type. If you must use {aEl}, point {aEl} records to our redirector box at <code>{info.redirector}</code> to redirect traffic to <em>www</em> equivalent. The equivalent <b>must</b> be set up using the {cnameEl}
						</li>
					</ul>
				);
				break;
			case 'EIP':
				description = (
					<ul>
						<li>Set {aEl} records to <code>{this.state.DomainInfo.A}</code></li>
					</ul>
				);
				break;
			case 'CWP':
				description = (
					<div>
						{this.getARecords()}
						{this.getCNAMERecords()}
						<p>Note that for domains that contain subdomains, one of those subdomains must be "www" (for example, for agency.govt.nz there must be a www.agency.govt.nz too)</p>
					</div>
				);
				break;
			default:
				description = (
					<p><em>We are unable to specify the configuration for your DNS at this time. Please contact the Service Desk for help.</em></p>
				)
				break;
		}

		return (
			<div>
				{description}
			</div>
		);
	}
});

module.exports = DomainInfo;
